import { render } from "./BannerJackpot.vue?vue&type=template&id=d064eabc&scoped=true"
import script from "./BannerJackpot.vue?vue&type=script&lang=js"
export * from "./BannerJackpot.vue?vue&type=script&lang=js"

import "./BannerJackpot.vue?vue&type=style&index=0&id=d064eabc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d064eabc"]])

export default __exports__